export const AuthorNameSeparator = (author) => {
  let displayAuthor = author;
  if (author.startsWith("|") && author.endsWith("|")) {
    displayAuthor = author.substr(1, author.length - 2);
  }
  return displayAuthor.includes("||")
    ? displayAuthor.split("||").join(", ")
    : displayAuthor.split("|").join(", ");
};
